// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { paymentTermSchema } from '@/payment-term/api/types';
import { z } from 'zod';

const paymentTermsResponseSchema = z
  .object({
    data: z.array(paymentTermSchema),
    metadata: responseMetadataSchema,
  })
  .transform(({ data, ...response }) => ({ ...response, paymentTerms: data }));

/**
 * Requests all payment terms from the remote API.
 */
export async function getPaymentTerms() {
  const response = await api.get(`/meta/payment-terms`);

  return parseResponse(paymentTermsResponseSchema, response.data, {
    schemaName: 'PaymentTerms',
    endpoint: '/meta/payment-terms',
  });
}
